import React, {useState, useEffect} from "react";
import "./secondSample.css"; // استایل‌های مرتبط با اسلایدر
import FadeSlider from "../accesories/slider/FadeSlider";
import {Col, Container, Image, Row} from "react-bootstrap";
import CustomButton from "../accesories/customBtn/CustomButton";


const SecondSample = () => {
    return (
        <div className={'fade-slider-wrapper'}>
            <FadeSlider>
                {/*<div style={{ background: "red", height: "100%", width: "100%" }}>
                <h2 style={{ color: "white" }}>اسلاید 1</h2>
            </div>
            <div style={{ background: "blue", height: "100%", width: "100%" }}>
                <h2 style={{ color: "white" }}>اسلاید 2</h2>
            </div>
            <div style={{ background: "green", height: "100%", width: "100%" }}>
                <h2 style={{ color: "white" }}>اسلاید 3</h2>
            </div>
            <div style={{ background: "purple", height: "100%", width: "100%" }}>
                <h2 style={{ color: "white" }}>اسلاید 4</h2>
            </div>*/}
                <div>
                    <Container>
                        <Row>
                            <Col sm={12} md={6}
                                 className={'right-col d-flex justify-content-center align-items-start flex-column'}>
                                <h2>گروه نرم افزاری داپا
                                </h2>
                                <p className={'text-end'}>برای موفقیت در کسب و کارت کافیه با ما همراه بشی ما در تمام
                                    لحظات
                                    کنارتیم تا همیشه
                                    بهترین باشی
                                </p>
                                <div className={'d-flex gap-3'}>
                                    <CustomButton icon={<i className="fa-regular fa-phone-flip"></i>}
                                                  bgColor={'#D3EDE6'} height={'4.5rem'}
                                                  width={'12.5rem'} href={'www.dapa.com'} text={'راهنمایی نیاز داری؟'}/>
                                    <CustomButton icon={<i className="fa-solid fa-arrow-turn-down-left"></i>}
                                                  bgColor={'#1D2E3D'}
                                                  color={'#fff'} width={'12.5rem'} height={'4.5rem'}
                                                  href={'www.dapa.com'} text={'با ما آشنا شو'}/>
                                </div>
                            </Col>
                            <Col sm={12} md={6} className={'d-flex align-items-center justify-content-center'}>

                                <Image src="images/06.png" alt=""/>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div>
                    <Container>
                        <Row>
                            <Col sm={12} md={6}
                                 className={'right-col d-flex justify-content-center align-items-start flex-column'}>
                                <h2>گروه
                                </h2>
                                <p className={'text-end'}>برای موفقیت در کسب و کارت کافیه با ما همراه بشی ما در تمام
                                    لحظات
                                    کنارتیم تا همیشه
                                    بهترین باشی
                                </p>
                                <div className={'d-flex gap-3'}>
                                    <CustomButton icon={<i className="fa-regular fa-phone-flip"></i>}
                                                  bgColor={'#D3EDE6'} height={'4.5rem'}
                                                  width={'12.5rem'} href={'www.dapa.com'} text={'راهنمایی نیاز داری؟'}/>
                                    <CustomButton icon={<i className="fa-solid fa-arrow-turn-down-left"></i>}
                                                  bgColor={'#1D2E3D'}
                                                  color={'#fff'} width={'12.5rem'} height={'4.5rem'}
                                                  href={'www.dapa.com'} text={'با ما آشنا شو'}/>
                                </div>
                            </Col>
                            <Col sm={12} md={6} className={'d-flex align-items-center justify-content-center'}>

                                <Image src="images/02.png" alt=""/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </FadeSlider>
        </div>
    );
};

export default SecondSample;





